/*@ngInject*/
const EmailModalController = function ($scope, $rootScope, options, coreConstant, coreMediator, localization, emailNotificationOption) {

    localization.getTranslations().then(function (root) {

        let translations = _.get(root, 'emailModal');
        $scope.viewModel = {
            emailSelection: emailNotificationOption.STANDARD,
            submissionId: (options.variables) ? options.variables.submissionId : options.submissionId,
            notificationTitle: options.notificationTitle,
            allowStandardEmail: true,
            emailNotificationOptions: emailNotificationOption,
            okButton: _.get(translations, 'confirmButton')
        };

        $scope.onConfirm = function () {
            $scope.$close({
                notificationName: options.variables.notificationName,
                selection: $scope.viewModel.emailSelection,
                submissionId: $scope.viewModel.submissionId,
                options: options
            });
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

        $scope.handleLabelClick = function (event, radioValue) {
            $scope.viewModel.emailSelection = radioValue;
        };

        if (options.variables) {
            if (!_.isNil(options.variables.defaultSelectedOption)) {
                $scope.viewModel.emailSelection = options.variables.defaultSelectedOption;
            }
            $scope.viewModel.allowStandardEmail = parseInt(options.variables.numberOfRecipients) > 0;
            if (!$scope.viewModel.allowStandardEmail && $scope.viewModel.emailSelection === emailNotificationOption.STANDARD) {
                $scope.viewModel.emailSelection = emailNotificationOption.NONE;
            }
        } else {
            localization.getTranslationByKey('emailModal.title').then(function (translation) {
                $scope.viewModel.notificationTitle = translation;
            });
        }
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('emailModalController', EmailModalController);
